import * as React from 'react';
/**
 *
 * Original name: help
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=400%3A1062
 *
 */
export const HelpLine = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { d: "M11.75 4C6.535 4 4 6.535 4 11.75s2.535 7.75 7.75 7.75 7.75-2.535 7.75-7.75S16.965 4 11.75 4Zm0 14c-4.322 0-6.25-1.927-6.25-6.25 0-4.322 1.928-6.25 6.25-6.25 4.323 0 6.25 1.928 6.25 6.25 0 4.323-1.927 6.25-6.25 6.25Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }),
    React.createElement("path", { d: "M11.75 14.5a.75.75 0 1 0 .75.75.71.71 0 0 0-.75-.75Zm.007-7h-.007A2.76 2.76 0 0 0 9 10.26v.24h1.5v-.24A1.256 1.256 0 0 1 11.75 9c.866 0 1.25.386 1.25 1.25 0 .887-.443 1.074-.588 1.136A2.244 2.244 0 0 0 11 13.428v.166a3.01 3.01 0 0 1 1.5 0v-.166a.75.75 0 0 1 .496-.66A2.532 2.532 0 0 0 14.5 10.25a2.55 2.55 0 0 0-2.743-2.75Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
